import React from "react";
import { Script } from "gatsby";

// strategy is set to "idle" by default to ensure that the scripts are loaded after the page content
const Scripts = ({ strategy = "idle" }) => <>
	<Script strategy={strategy}
		async id="cylindo-viewer-script"
		src="https://viewer-cdn.cylindo.com/v1/index.mjs" type="module" />

	<Script strategy={strategy}
		async id="gorgias-chat-widget-install-v3"
		src="https://config.gorgias.chat/bundle-loader/01GYCCSF2EF4RGHZ8WZY1QGK2Y" />

	<Script strategy={strategy}
		async id="okendo-reviews-widget-plus"
		src="https://cdn-static.okendo.io/reviews-widget-plus/js/okendo-reviews.js" />

	<Script strategy={strategy}
		async id="amped"
		src="https://app.amped.io/snippet/account_lwm2tha" />

	<Script strategy={strategy}
		async id="mailchimp-form"
		src="https://form-assets.mailchimp.com/snippet/account/219772586" />
</>;

export default Scripts;